import ContentLayout from "../../layout/contentLayout";
import PeopleIcon from "@mui/icons-material/People";
import Content from "./content";
/**
 * CustomerMyOrganization
 *
 * صفحه نمایش سازمان‌های کاربر در داشبورد.
 * این کامپوننت شامل:
 * - استفاده از ContentLayout برای ساختار صفحه
 * - آیکون نماینده سازمان‌ها (PeopleIcon)
 * - عنوان صفحه "سازمان های من"
 * - محتوا با استفاده از کامپوننت Content
 *
 * ویژگی‌ها:
 * - isContainerFluid برای استفاده از پهنای کامل کانتینر
 *
 * @returns JSX.Element
 */
const CustomerMyOrganization = () => {
  return (
    <ContentLayout icon={<PeopleIcon />} title="سازمان های من" isContainerFluid>
      <Content />
    </ContentLayout>
  );
};

export default CustomerMyOrganization;
